import React, { Fragment } from "react";
import { ActionTypes } from "../../../utils/types";
import {
  Checkpoint,
  CheckpointRating,
  CheckpointType,
} from "../../../lib/ground-aws-graphql-core/models/Api/Inspection";
import CheckpointComponentRating from "../../Tailwind/CheckpointRating";

interface Props {
  checkpointType: CheckpointType;
  ratings: CheckpointRating[];
  items: {
    checkpointType: CheckpointType;
    checkpoint: Checkpoint;
    action: ActionTypes;
  }[];
}

const ListCheckpointRatings = (props: Props): JSX.Element => {
  const { items, checkpointType, ratings } = props;

  const checkpoints = items.filter(
    e => checkpointType.id === e.checkpointType.id
  );

  return (
    <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:py-6 sm:px-6 px-2 py-2 bg-ground-white-200 rounded-b-10">
      {checkpoints.map((i, index) => {
        return (
          <Fragment key={index}>
            <CheckpointComponentRating
              checkpoint={i.checkpoint}
              ratings={ratings}
            />
          </Fragment>
        );
      })}
    </div>
  );
};

export default ListCheckpointRatings;
